module.exports = __webpack_public_path__ + "img/n2.e4412eb9.gif";